import React, { useContext, useEffect, useState } from 'react'
import { formatDate, getSampleCsvHeadings, ROUTES } from '../../../shared/constants'
import { useHistory } from 'react-router'

import { OtherContext } from '../../../context api/Others/OtherContext'
import { useDownload } from '../../../hooks/Download/useDownload'
import CustomTableLayout from '../../../components/CustomComponents/CustomTableLayout'
import { useAuditTask } from '../../../hooks/Others/Audit/useAuditTask'
import CustomDialog from '../../../components/CustomDialog'
import CustomHeading from '../../../components/CustomHeading'
import { Box, Grid, makeStyles, Typography } from '@material-ui/core'
import CustomLabel from '../../../components/CustomLabel'
import CustomImage from '../../../components/CustomImage'
import CustomSlider from '../../../components/CustomSlider'
import CustomButton from '../../../components/CustomButton'
const useStyles = makeStyles((theme) => ({
  image: {
    width: '100%',
  },
  dialog: {
    minWidth: '800px',
  },
  button: {
    // marginRight: '10px',
    width: '140px',
    // padding: '5px',
    backgroundColor: 'grey',
    '&:hover': {
      backgroundColor: 'grey',
    },
    marginRight: '10px',
  },
  button2: {
    // marginRight: '10px',
    width: '140px',
    // padding: '5px',
    // backgroundColor: theme.palette.error.main,
    // '&:hover': {
    //   backgroundColor: theme.palette.error.main,
    // },
  },
}))
export default function AuditTask() {
  const classes = useStyles()
  const { getAllAuditTask, deleteManyAuditTask, loading, paginate, updateAuditsTask } = useAuditTask()
  const { downloadLoading, getPdfCsvData, pdfCsvData } = useDownload()
  const { auditTasks } = useContext(OtherContext)
  //console.log('auditTasks : ', auditTasks)
  const history = useHistory()

  const [searchQuery, setSearchQuery] = useState('')
  const filterAuditTask = auditTasks && auditTasks.filter((val) => val && val.employee && val.store && val.task)
  const [page, setPage] = React.useState(1)
  const [taskDetail, setTaskDetail] = React.useState(false)
  const [approveDialog, setApproveDialog] = React.useState(false)
  const [declineDialog, setDeclineDialog] = React.useState(false)

  const noOfPages = paginate && paginate.totalPage
  useEffect(() => {
    getAllAuditTask({
      page: page,
      limit: 10,
      searchQuery,
    })
  }, [page, searchQuery])

  useEffect(() => {
    getPdfCsvData('GET_ALL_TASK')
  }, [])

  const handleChange = (event, value) => setPage(value)

  let tableBody = []

  if (!loading && filterAuditTask.length > 0) {
    tableBody = filterAuditTask.map((item) => {
      return [
        // { type: 'CHECKBOX', _id: item._id },
        { value: `${item.employee.firstName} ${item.employee.lastName}` },
        { value: item.store.name },
        { value: item.store.storeCode },
        { type: 'VIEW', onClick: () => setTaskDetail(item) },
        { status: item.status, type: 'STATUS_ENUM' },
        { type: 'ACTION', approveDialog: () => setApproveDialog(item), declineDialog: () => setDeclineDialog(item), display: item.status === 'COMPLETED' ? true : false },
      ]
    })
  }
  const sampleHeader = getSampleCsvHeadings(['taskType', 'name', 'description'])
  const layoutProps = {
    heading: 'Audit Tasks',
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    filename: 'auditTasks',
    headers: pdfCsvData.headings,
    data: pdfCsvData.headingValues,
    downloadLoading,
    permissionName: 'AUDIT',
    // sampleName: 'sample_task',
    // sheetName: 'taskMaster',
    tempHeaders: sampleHeader,
    // url: ROUTES.ADD_TASK,
    editUrl: `/edit-task/`,
  }
  //

  const CustomActionDialog = () => {
    return (
      <CustomDialog
        open={approveDialog || declineDialog}
        handleClose={() => {
          setApproveDialog(false)
          setDeclineDialog(false)
        }}
      >
        <Box textAlign="center">
          <CustomHeading heading={`Are You Sure Want to ${approveDialog ? 'Approve' : 'Reject'}`} />
          <br />

          <CustomHeading heading="The Task ?" />
          <br />
          <br />
          <Box display="flex" justifyContent="center">
            <CustomButton
              text="Cancel"
              handleSubmit={() => {
                setApproveDialog(false)
                setDeclineDialog(false)
              }}
              className={classes.button}
            />

            <CustomButton
              text={`${approveDialog ? 'Approve' : 'Reject'}`}
              className={classes.button2}
              handleSubmit={() => {
                updateAuditsTask({
                  taskId: approveDialog._id || declineDialog._id,
                  status: approveDialog ? 'COMPLETE' : 'REOPEN',
                })
                setApproveDialog(false)
                setDeclineDialog(false)
                setPage(1)
                // window.location.reload()
              }}
            />
          </Box>
        </Box>
      </CustomDialog>
    )
  }

  return (
    <>
      <CustomActionDialog />
      {taskDetail && (
        <CustomDialog open={taskDetail} handleClose={() => setTaskDetail(false)} heading="Task Detail" className={classes.dialog}>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <CustomHeading heading="Task Name : " />
            <CustomLabel label={taskDetail.task.name} />
          </Box>
          <br />
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <CustomHeading heading="Task Description : " />
            <CustomLabel label={taskDetail.task.description} />
          </Box>
          <br />

          <Box display="flex" alignItems="center" justifyContent="space-between">
            <CustomHeading heading="Closure Date : " />
            <CustomLabel label={formatDate(taskDetail.closureDate)} />
          </Box>
          <br />
          {taskDetail.reClosureDate && (
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <CustomHeading heading="Re Closure Date : " />
              <CustomLabel label={formatDate(taskDetail.reClosureDate)} />
            </Box>
          )}
          <br />
          <CustomHeading heading={`Total Images : ${taskDetail.images.length}`} />
          <br />

          {taskDetail.images.map((item, index) => (
            <div style={{ position: 'relative' }}>
              <Typography style={{ position: 'absolute', top: '10px', left: '10px', background: 'white', padding: '5px', borderRadius: '5px', fontWeight: 'bold' }}>
                {index + 1} / {taskDetail.images.length}{' '}
              </Typography>
              <CustomImage image={item} className={classes.image} />
              <br />
              <br />
            </div>
          ))}
        </CustomDialog>
      )}

      <CustomTableLayout
        tableHeadings={['Employee', 'Store name', 'store code', 'view task', 'status', 'action']}
        loading={loading}
        tableBody={tableBody}
        handlePageChange={handleChange}
        paginate={{ totalPage: noOfPages, page: page }}
        layoutProps={layoutProps}
        deleteMany={(val, setSelected) => deleteManyAuditTask({ taskId: val }, setSelected)}
        // checkbox
      />
    </>
  )
}
